
<div class="row z-ind-5" *ngIf="onCallMembers && onCallThisWeek && hideBox" style="margin-bottom:5px; width: 230px">
  <div class="col-xs-12 card p-3 shadow" *ngIf="!editOnCallFlag && onCallThisWeek">
    <div class="col-xs-12 textC px-0">
      <div class="col-xs-10 title bold fontR">{{this.currentUserName}}</div>
      <div class="fas fa-times pull-right fontR" (click)="hideBox = !hideBox"></div>
    </div>
  </div>
</div>
